export const IMG = {
    TON: 'https://raw.githubusercontent.com/ton-connect/sdk/main/assets/ton-icon-48.png',
    TG: 'https://raw.githubusercontent.com/ton-connect/sdk/main/assets/tg.png',
    WALLET_CONNECT:
        'https://raw.githubusercontent.com/ton-connect/sdk/main/assets/walletconnect-icon-288.png'
};
